export const SET_PILL_OPTIONS_SOURCE = 'SET_PILL_OPTIONS_SOURCE';
export const FETCH_PILL_OPTIONS_STUB = 'FETCH_PILL_OPTIONS_STUB';
export const FETCH_PILL_OPTIONS_STUB_DONE = 'FETCH_PILL_OPTIONS_STUB_DONE';
export const FETCH_PILL_OPTIONS_STUB_ERR = 'FETCH_PILL_OPTIONS_STUB_ERR';
export const SET_PILL_OPTIONS_STUB = 'SET_PILL_OPTIONS_STUB';
export const FETCH_PILL_OPTIONS_NAME = 'FETCH_PILLS_OPTIONS_NAME';
export const FETCH_PILL_OPTIONS_NAME_DONE = 'FETCH_PILLS_OPTIONS_NAME_DONE';
export const FETCH_PILL_OPTIONS_NAME_ERR = 'FETCH_PILLS_OPTIONS_NAME_ERR';
export const SET_PILL_OPTIONS_NAME = 'SET_PILLS_OPTIONS_NAME';
export const FETCH_PILL_OPTIONS_FORM = 'FETCH_PILLS_OPTIONS_FORM';
export const FETCH_PILL_OPTIONS_FORM_DONE = 'FETCH_PILLS_OPTIONS_FORM_DONE';
export const FETCH_PILL_OPTIONS_FORM_ERR = 'FETCH_PILLS_OPTIONS_FORM_ERR';
export const SET_PILL_OPTIONS_FORM = 'SET_PILLS_OPTIONS_FORM';
export const FETCH_PILL_OPTIONS_STRENGTH = 'FETCH_PILLS_OPTIONS_STRENGTH';
export const FETCH_PILL_OPTIONS_STRENGTH_DONE = 'FETCH_PILLS_OPTIONS_STRENGTH_DONE';
export const FETCH_PILL_OPTIONS_STRENGTH_ERR = 'FETCH_PILLS_OPTIONS_STRENGTH_ERR';
export const SET_PILL_OPTIONS_STRENGTH = 'SET_PILLS_OPTIONS_STRENGTH';
export const SET_PILL_OPTIONS_SEARCH_STRING = 'SET_PILL_OPTIONS_SEARCH_STRING';
export const SET_PILL_OPTIONS_TYPE = 'SET_PILL_OPTIONS_TYPE';
export const SET_PILL_OPTIONS_EXPIRES = 'SET_PILL_OPTIONS_EXPIRES';
export const SET_PILL_OPTIONS_SCHEDULES = 'SET_PILL_OPTIONS_SCHEDULES';
export const SET_PILL_OPTIONS_STORED_IN_HERO = 'SET_PILL_OPTIONS_STORED_IN_HERO';
export const RESET_PILL_OPTIONS = 'RESET_PILL_OPTIONS';
//# sourceMappingURL=actionTypes.js.map